import { FieldProps } from "../../types";

interface DevicePressureEditorProps extends FieldProps<string> {}

const DevicePressureEditor: React.FC<DevicePressureEditorProps> = () => {
  return <></>;
};

export default DevicePressureEditor;
